import { createContext } from 'react';
import { createMongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

import { Actions, Subjects } from './types';

export const AbilityContext = createContext(createMongoAbility<[Actions, Subjects]>());
export const Can = createContextualCan(AbilityContext.Consumer);
